export const roles = {
  1: "администратор",
  2: "закройщик",
  3: "владелец",
  4: "руководитель",
  5: "кладовщик",
  6: "швея",
  7: "ОКК",
  8: "Менеджер по продажам",
};



// WEBPACK FOOTER //
// ./src/_shared/constants/roles.js